import {ToyTypeForgeDocument} from '@/models/totype.model';

/**
 * Représente la structure de données renvoyée par les requêtes :
 * - addScreen (screen.axios.ts)
 * - updateScreen (screen.axios.ts)
 * - fetchAllScreens (screen.axios.ts)
 */
export interface ScreenDocumentFlat {
  _id: string
  prjid: string
  name: string
  description: string
  screenshot: string
  packid: string | null
}

/**
 * Représente la structure de données renvoyée par la requête :
 * - getScreen (screen.axios.ts)
 */
export interface ScreenDocument extends  ScreenDocumentFlat{
  toys: ScreenToyDocument[]
}
export interface ScreenToyDocument {
  _id: string
  kind: 'Toy'
  name: string
  type: ToyTypeForgeDocument
  screen: string
  mapping: {key: string, value: string}[]
  position: {x: number, y: number, width: number, height: number}
}

export interface ScreenShot {
  shotid: string;
  shoturl: string | null;
}

/**
 * Payload de la requête fetch all screens
 */
export interface ScreenPayload {
  prjid : string
  packid?: string | null
  searchText?: string | null
}

export interface ScreensMovePayload {
  packid: string | null
  screenids: string[]
}
/**
 * Id de package fictif dans la liste des packages pour identifier les écrans sans package associé
 */
export const UNPACKID = 'xxx'
